module.exports = __webpack_public_path__ + "static/media/fig_1_AC.211fc2f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_1_AC.jpg
// module id = 651
// module chunks = 0